import { externalClient } from './client/externalClient'

const useMetadataApi = () => {
  const get = async <T>(key: string): Promise<T|null> => {
    try {
      const { value } = (await externalClient.get(`/frontend/metadata/${key}`)).data as { value: string }
      return JSON.parse(value)
    } catch (e) {
      return null
    }
  }

  const getLearningPathProgress = async (learningPathLocationId: number): Promise<number> => {
    const { previousLocationId } = (await get<{ previousLocationId: number }>(`learningPathProgress-${learningPathLocationId}`)) || { previousLocationId: 0 }
    return previousLocationId
  }

  return {
    get,
    getLearningPathProgress
  }
}

export default useMetadataApi
